import { FC, memo, useEffect, useState, useRef } from "react"
import styles from "./styles.module.scss";
import { useQuery } from "react-query";
import { API_SEARCH_OFFERS } from "api";


interface Props {
    callback: (value: any) => void,
    public_id?: string
}

export const Service:FC<Props> = memo(({ callback, public_id }) => {

    const [ searchValue, setSearchValue ] = useState<string>("");
    const [ selected, setSelected ] = useState<Record<string, any>|undefined>(undefined);
    const [ services, setServices ] = useState<Array<{id: number|string, title: string, description: string, author_id: string, user_display_name: string}>>([]);
    const inputRef = useRef<HTMLInputElement>(null);
    //console.log("public_id in Service component", public_id);
    const {
        data,
        isLoading,
        isSuccess
    } = useQuery({
        enabled: searchValue.length > 1,
        queryFn: API_SEARCH_OFFERS,
        queryKey: ["SEARCH_OFFERS", {limit: 10, offset: 1, q: searchValue, author_id: public_id}],
    });

    const handleChange = (e) => {
        const value = e.target.value || "";
        setSearchValue(value);
    }

    const handleSelect = (value: Record<string, any>) => {
        setSelected(value);
        setSearchValue(""); // Clear the input value after selection
        // Also clear the input field directly using ref
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        callback(value)
        setServices([]);
    }



    useEffect(() => {
        if (!isLoading && isSuccess && data) {
            const result = data?.offers.map(({ id, title, description, author_id, author }) => {
                //console.log("author", author);
                let user_display_name = author.is_email_visible ? author?.email : author?.username;
                const phone_display = author.is_phone_visible ? (author?.extra_information.phone_mobile || author?.extra_information.phone_residence) : "";
                //console.log("phone_display", phone_display);
                user_display_name = `${user_display_name} ${(phone_display ? `(${phone_display})` : "")}`;
                //console.log("user_display_name", user_display_name);
                return {id, title, description, author_id, user_display_name: user_display_name};
            })
            setServices(result)
        }
    }, [isLoading, isSuccess, data])

    return (
        <div className={styles.container}>
            <input
                ref={inputRef}
                className={[styles.input].join("")}
                type="text"
                id="service"
                name={"serivce"}
                placeholder={"Service"}
                onChange={(e) => handleChange(e)}
                value={searchValue}
            />
            <ul className={styles.service_block_options}>
            {services.map(({ id, title, description, author_id, user_display_name}) => (
                    <li
                        className={styles.service_block_options_option}
                        key={id}
                        onClick={() => handleSelect({ id, title, description, author_id, user_display_name})}
                    >
                        {`${title} - ${user_display_name || ''}` }
                    </li>
                ))}
            </ul>
        </div>
    )
})